const Builder = require('../BuilderBase');

module.exports = class Image extends Builder {
    /**
     * @param {string} title
     * @param {*} properties
     */
    constructor(title, properties) {
        super('formElement_Image', title, properties);
        if (!properties.namespace || !properties.relation)
            throw new Error('For Images you must specify a namespace and relation');
    }
};
